import React, {
  createContext,
  useContext,
  useState,
  ReactNode
} from 'react';

// ✅ Tipo de usuario
type User = {
  id: string;       // Supabase devuelve id como string (uuid)
  email: string;
  rol: 'entrenador' | 'usuario';
} | null;

// ✅ Tipo del contexto
type AuthContextType = {
  user: User;
  login: (userData: User, token: string) => void;
  logout: () => void;
};

// ✅ Crear contexto
const AuthContext = createContext<AuthContextType | undefined>(undefined);

// ✅ Proveedor del contexto
export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User>(null);

  const login = (userData: User, token: string) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// ✅ Hook para usar el contexto
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
};
